import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  Stack,
  Box,
  Skeleton,
  Paper,
} from '@mui/material';
import { ProductViewMode } from './types';

const SKELETON_COUNT = 6;

interface ProductListSkeletonProps {
  viewMode?: ProductViewMode;
}

export const ProductListSkeleton: React.FC<ProductListSkeletonProps> = ({ viewMode = 'cards' }) => {
  if (viewMode === 'list') {
    return (
      <Paper variant="outlined" sx={{ borderColor: 'divider', overflow: 'hidden' }}>
        <Box sx={{ bgcolor: '#f1f5f2', px: 2, py: 1.5 }}>
          <Skeleton variant="text" width="45%" height={20} />
        </Box>
        <Stack divider={<Box sx={{ borderTop: '1px solid', borderColor: 'divider' }} />}>
          {Array.from({ length: 8 }).map((_, index) => (
            <Box
              key={index}
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', md: '2fr 1fr 1fr 1.3fr 0.8fr 40px' },
                gap: 2,
                alignItems: 'center',
                px: 2,
                py: 1.5,
              }}
            >
              <Box>
                <Skeleton variant="text" width="80%" height={24} />
                <Skeleton variant="text" width="30%" height={18} />
              </Box>
              <Skeleton variant="text" width="70%" />
              <Skeleton variant="text" width="70%" />
              <Skeleton variant="rounded" width={138} height={24} />
              <Skeleton variant="text" width="70%" />
              <Skeleton variant="circular" width={32} height={32} />
            </Box>
          ))}
        </Stack>
      </Paper>
    );
  }

  return (
    <>
      {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
        <Grid item xs={12} sm={6} lg={4} key={index}>
          <Card sx={{ height: 200 }}>
            <CardContent>
              <Stack direction="row" spacing={2} alignItems="flex-start" mb={2}>
                <Skeleton variant="circular" width={48} height={48} />
                <Box sx={{ flexGrow: 1 }}>
                  <Skeleton variant="text" width="80%" height={28} />
                  <Skeleton variant="text" width="40%" height={20} />
                </Box>
              </Stack>
              <Skeleton variant="text" width="100%" />
              <Skeleton variant="text" width="60%" />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </>
  );
};
